import type {
  EdgeCenterLabel,
  EdgeLinecapLabel,
  PathLookupEdgeSettings,
  TopologyEdgeSettings,
} from '@ipfabric/utils';
import { getEdgeAttribute } from './getEdgeAttribute';

export type EdgeLabel = EdgeCenterLabel | EdgeLinecapLabel;
export type EnabledCenterLabels = { [Key in EdgeCenterLabel]?: boolean };
export type EnabledLinecapLabels = { [Key in EdgeLinecapLabel]?: boolean };
export type EnabledLabels = EnabledCenterLabels & EnabledLinecapLabels;
export interface EnabledProtocolLabels {
  center: EnabledCenterLabels;
  linecap: EnabledLinecapLabels;
}

export const getProtocolLabels = (
  edge: TopologyEdgeSettings | PathLookupEdgeSettings,
): EnabledProtocolLabels => {
  const activeLabels = new Set(edge.labels);

  return {
    center: getEdgeAttribute(edge).labels.center.reduce(
      (acc: EnabledCenterLabels, label): EnabledCenterLabels => {
        acc[label] = activeLabels.has(label);
        return acc;
      },
      {},
    ),
    linecap: getEdgeAttribute(edge).labels.linecap.reduce(
      (acc: EnabledLinecapLabels, label): EnabledLinecapLabels => {
        acc[label] = activeLabels.has(label);
        return acc;
      },
      {},
    ),
  };
};
